'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactBootstrap = require('react-bootstrap');

var ReactBootstrap = _interopRequireWildcard(_reactBootstrap);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/*
 * Vegetable Serve information
 */
var VegetableServe = function (_Component) {
  (0, _inherits3.default)(VegetableServe, _Component);

  function VegetableServe() {
    (0, _classCallCheck3.default)(this, VegetableServe);
    return (0, _possibleConstructorReturn3.default)(this, (VegetableServe.__proto__ || (0, _getPrototypeOf2.default)(VegetableServe)).apply(this, arguments));
  }

  (0, _createClass3.default)(VegetableServe, [{
    key: 'render',
    value: function render() {
      var vegeServe = require('../Assets/vegeserve.png');
      var vegeHandServe = require('../Assets/vegehandserve.png');
      var styles = require('../../Modules.scss');

      return _react2.default.createElement(
        'div',
        null,
        _react2.default.createElement(
          'strong',
          null,
          'One serve of vegetables is equivalent to:'
        ),
        _react2.default.createElement('br', null),
        _react2.default.createElement(
          ReactBootstrap.Col,
          { md: 7 },
          _react2.default.createElement(
            'ul',
            null,
            _react2.default.createElement(
              'li',
              null,
              _react2.default.createElement(
                'span',
                null,
                '1/2 cup green or orange vegetables (for example, broccoli, carrots or pumpkin)'
              )
            ),
            _react2.default.createElement(
              'li',
              null,
              _react2.default.createElement(
                'span',
                null,
                '1/2 cup cooked dried or canned beans, peas or lentils (preferably with no added salt)'
              )
            ),
            _react2.default.createElement(
              'li',
              null,
              _react2.default.createElement(
                'span',
                null,
                '1 cup green leafy vegetables of raw salad leaves'
              )
            ),
            _react2.default.createElement(
              'li',
              null,
              _react2.default.createElement(
                'span',
                null,
                '1/2 cup sweet corn'
              )
            ),
            _react2.default.createElement(
              'li',
              null,
              _react2.default.createElement(
                'span',
                null,
                '1/2 medium potato or other starchy vegetables (sweet potato, taro or cassava)'
              )
            ),
            _react2.default.createElement(
              'li',
              null,
              _react2.default.createElement(
                'span',
                null,
                '1 medium tomato'
              )
            )
          ),
          _react2.default.createElement('div', { className: styles.spacer20 }),
          _react2.default.createElement(ReactBootstrap.Image, { src: vegeHandServe, className: styles.image60 + ' center-block', responsive: true }),
          _react2.default.createElement(
            'p',
            { className: styles.greenText },
            'Notice that using your hand is often a good reference size. One serve of vegies is about as much as can fit in the palm of an adult or 2 to 3 tablespoons worth.'
          )
        ),
        _react2.default.createElement(
          ReactBootstrap.Col,
          { md: 5 },
          _react2.default.createElement(
            'p',
            { className: styles.greenText + ' center-block' },
            'Each of these is an example of "one serve"'
          ),
          _react2.default.createElement(ReactBootstrap.Image, { src: vegeServe, responsive: true })
        )
      );
    }
  }]);
  return VegetableServe;
}(_react.Component);

exports.default = VegetableServe;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/components/ServeInformation/VegetableServe/VegetableServe.js
// module id = 1268
// module chunks = 0